export default __webpack_public_path__ + "static/media/titanium_trace_icon.f8e038a2.png";